export default "__VITE_ASSET__DcbD8Gx7__"